/**
 * CMS router
 * 
 */

import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Prismic from 'prismic-javascript';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import 'whatwg-fetch';

// Functions

import Helpers from './functions/helpers';
import Config from './config';

// Containers

import App from '../containers/app';

export default class CMS extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			
			prismicCtx: null,
			navigation: null,
			settings: null,
			device: null
		}
	}

	componentWillMount() {

		this.buildContext().then((prismicCtx) => { this.setState({ prismicCtx }); }).catch((e) => { console.error(`Cannot contact the API, check your prismic configuration:\n${e}`); });
	}

	getNavigation(api) {
	
		api.query([Prismic.Predicates.at('document.type', 'menu')]).then(response => { this.setState({ navigation: response.results }); });
	}

	getWebsiteSettings(api) {
	
		api.query([Prismic.Predicates.at('document.type', 'settings')]).then(response => { this.setState({ settings: response.results }); this.setWebsiteTracking(); });
	}

	getDeviceSettings() {
		
		const browser = navigator.userAgent;

		Helpers.publicIP().then(ip => { this.setState({ device: { ip: ip, browser: browser } }); });
	}

	setWebsiteTracking() {
		
		if (process.env.NODE_ENV !== 'development') {

			const google = this.state.settings[0].data.google_analytics_id;
			const facebook = this.state.settings[0].data.facebook_pixel;

			let tracking = [];

			if (google) {

				ReactGA.initialize(google.toString());
				tracking.push('google');
			}

			if (facebook) {

				ReactPixel.init(facebook.toString());
				tracking.push('facebook');
			}

			global.Analytics = tracking;
		}
	}

	buildContext() {

		const accessToken = Config.accessToken;
		
    	return Prismic.api(Config.apiEndpoint, { accessToken })
			
			.then(api => ({ 
				
    			api, 
    			accessToken, 
    			endpoint: Config.apiEndpoint, 
    			linkResolver: Helpers.linkResolver, 
    			navigation: this.getNavigation(api), 
    			settings: this.getWebsiteSettings(api),
    			device: this.getDeviceSettings()
			})
		);
	}

	render() {
		
		return (
			
			<Router>
				<App cms={this.state.prismicCtx} navigation={this.state.navigation} device={this.state.device} settings={this.state.settings && this.state.settings.length && this.state.settings[0].data} />
			</Router>
		);
	}
}



// WEBPACK FOOTER //
// ./src/utils/cms.js